import {TrustPilotReview} from '@vio/core/src/trustpilotWidget/types'

export const IDEAL_REVIEW_LENGTH = 200

/**
 * Picks the review whose text length is nearest `targetLength`, counting every
 * character. Reviews without text count as empty, and the first of equally
 * distant reviews wins.
 */
export const getReviewClosestToLength = (
  reviews: TrustPilotReview[] | undefined,
  targetLength = IDEAL_REVIEW_LENGTH
): TrustPilotReview | undefined => {
  if (!reviews || reviews?.length === 0) return undefined

  const distanceToTarget = (review: TrustPilotReview) =>
    Math.abs((review.text?.length ?? 0) - targetLength)

  return reviews.reduce<TrustPilotReview | undefined>(
    (closest, review) =>
      !closest || distanceToTarget(review) < distanceToTarget(closest)
        ? review
        : closest,
    undefined
  )
}
